/**
 * 수주포인트내역 페이지
 * 레거시 _sky__m_menu_setting_07.php?ontab=1 (= _sky__m_menu_setting_07_01.php) 대체
 */
import Util from '../../Common/Util';
export default class Point {
    constructor() {
        this.$table = null;
        this.lastClickedNum = null;
        this.maxAble = 0;
    }

    initialize() {
        const self = this;
        this.maxAble = parseInt($('#pmax-count').text(), 10) || 0;

        this._initTable();
        this._initExchange();
        this._initHelp();
        this._initGivePoint();

        this._renderFilterChip();
        $(document).off('click', '.js-filter-clear').on('click', '.js-filter-clear', () => this._setOrdernumFilter(0));
    }

    _initTable() {
        const self = this;
        this.$table = new DataTable('#point-sooju-table', {
            autoWidth: false,   // 글자크기 zoom 과 겹쳐 표가 컨테이너 밖으로 밀린다 — RelationSpecial.js 주석 참고
            ajax: {
                url: '/m/ajax/point/list',
                type: 'POST',
                data: (d) => {
                    d.usednot = $('#usednot-check').is(':checked') ? 1 : 2;
                    d.ordernum = parseInt($('#ordernum-search').val(), 10) || 0;
                    return d;
                },
            },
            serverSide: true,
            processing: true,
            ordering: false,
            lengthChange: false,
            pageLength: 25,
            dom: 'tip',
            language: {
                emptyTable: '내역이 없습니다.',
                info:       '총 _TOTAL_건 중 _START_~_END_',
                infoEmpty:  '',
                processing: '불러오는 중…',
                paginate:   { first: '처음', last: '끝', next: '다음', previous: '이전' },
            },
            columns: [
                { data: 'datetime', orderable: false, className: 'td_date' },
                {
                    data: null, orderable: false,
                    render: (row) => {
                        // 작업노트는 내용 글자를 누르면 노트가 행 아래에 펼쳐진다 (행 탭 = 오더상세와 별개)
                        // exp 에는 추천인 이름·관리자 메모가 섞여 온다 — 이스케이프하고 서버가 붙인 <br> 만 살린다
                        const expHtml = Util.escapeHtml(row.exp).replace(/&lt;br&gt;/g, '<br>');
                        const exp = row.is_worknote
                            ? `<a href="javascript:void(0)" class="js-row-note" data-num="${row.num}" data-rel-id="${row.rel_id}">${expHtml}</a>`
                            : `<span>${expHtml}</span>`;
                        // 오더 줄은 눌린다(→ 오더상세 BS)는 걸 쉐브론으로 알린다 — 예전엔 날짜를 눌러야 열려서 아무도 몰랐다
                        return row.rel_table === 'order' ? `${exp}<i class="pt-chev" aria-hidden="true">›</i>` : exp;
                    },
                    className: 'dt-body-left',
                },
                { data: 'point', orderable: false, className: 'dt-body-right', render: (v) => v },
                { data: 'total_point', orderable: false, className: 'dt-body-right' },
                {
                    // 오더번호 — 누르면 목록을 그 오더의 내역으로 거른다 (줄의 다른 곳을 누르면 오더상세 BS)
                    data: null, orderable: false, className: 'dt-body-center',
                    render: (row) => row.rel_table === 'order'
                        ? `<a href="javascript:void(0)" class="js-filter-order" data-ordernum="${row.rel_id}">${row.rel_id}</a>`
                        : '',
                },
            ],
            createdRow: (tr, row) => {
                $(tr).attr('id', `tr_list_${row.num}`);
                $(tr).attr('data-num', row.num);
                if (row.rel_table === 'order') $(tr).addClass('is-order').attr('data-ordernum', row.rel_id);
            },
            drawCallback: () => self._bindRowEvents(),
        });

        $('#usednot-check').on('change', () => self.$table.ajax.reload());
    }

    _bindRowEvents() {
        const self = this;
        const $tbl = $('#point-sooju-table');
        // 오더 줄 탭 → 오더상세 BS (작업내용 + 이 오더의 포인트 모아보기)
        $tbl.off('click', 'tr.is-order').on('click', 'tr.is-order', function () {
            $j.Ui.BS.open({
                target: '$j.F.Mobile.OrderSheet',
                fixedHeight: true,
                data: { ordernum: parseInt($(this).data('ordernum'), 10), logs: 'point' },
            });
        });
        $tbl.off('click', '.js-row-note').on('click', '.js-row-note', function (e) {
            e.stopPropagation();   // 행 탭(오더상세)까지 가지 않게
            const $el = $(this);
            self._toggleNote(parseInt($el.data('num'), 10), parseInt($el.data('rel-id'), 10));
        });
        $tbl.off('click', '.js-filter-order').on('click', '.js-filter-order', function (e) {
            e.stopPropagation();   // 행 탭(오더상세)까지 가지 않게
            self._setOrdernumFilter(parseInt($(this).data('ordernum'), 10) || 0);
        });
    }

    _setOrdernumFilter(ordernum) {
        $('#ordernum-search').val(ordernum);
        this._renderFilterChip();
        this.lastClickedNum = null;
        this.$table.ajax.reload();
    }

    _renderFilterChip() {
        const ordernum = parseInt($('#ordernum-search').val(), 10) || 0;
        const $chip = $('#order-filter-chip');
        if (ordernum > 0) {
            $chip.html(`<span>오더 #${ordernum}</span><button type="button" class="js-filter-clear" aria-label="필터 해제">×</button>`).css('display', 'flex');
        } else {
            $chip.empty().hide();
        }
    }

    /** 작업노트 줄 — 노트 본문을 행 아래에 펼친다 (다시 누르면 닫힘) */
    _toggleNote(num, ordernum) {
        const self = this;

        // 이미 열린 것 같은걸 클릭 → 닫기
        if (self.lastClickedNum === num) {
            $(`#tr_detail_${num}`).remove();
            self.lastClickedNum = null;
            return;
        }

        // 다른 detail 닫기
        if (self.lastClickedNum !== null) {
            $(`#tr_detail_${self.lastClickedNum}`).remove();
        }

        // 새 detail 행 추가
        const $detailTr = $(`<tr id="tr_detail_${num}"><td colspan="5"><div style="text-align:center;width:100%;background:white;color:black;height:120px;line-height:120px;font-weight:bold">상세정보를 불러오고 있습니다.</div></td></tr>`);
        $(`#tr_list_${num}`).after($detailTr);
        self.lastClickedNum = num;

        $.ajax({
            type: 'GET',
            url: `/m/ajax/order/${ordernum}/note`,
            success: (data) => {
                $detailTr.find('td').html(data);
            },
        });
    }

    _initExchange() {
        const self = this;
        $('#btn-exchange').on('click', () => {
            let val = parseInt($('#changetocntvalue').val(), 10);
            if (isNaN(val)) val = 0;
            if (val === 0) {
                Util.swalert('교환할 갯수를 숫자로 입력해 주세요');
                return;
            }
            if (val > self.maxAble) {
                Util.swalert(`최대 ${self.maxAble}개 까지 변경 가능합니다.`);
                return;
            }
            const need = val * 100;
            Util.swalert([`수주 포인트를 ${need}포인트 차감하고 발주개수 ${val}개로 교환 할까요?`, 'question'], () => {
                $.ajax({
                    type: 'POST',
                    url: '/m/ajax/point/exchange',
                    data: { balamtset: val },
                    success: (data) => {
                        if (data.result) {
                            location.reload();
                            return;
                        }
                        Util.swalert(data.message);
                    },
                });
            }, ['교환하기', '아니오']);
        });
    }

    _initHelp() {
        $('#btn-help').on('click', () => {
            $j.Ui.BS.open({
                fixedHeight: true,
                target: {
                    init() {
                        this.parent.setTitle('포인트 적립 안내');
                        $('#' + this.id).html($('#help-content-tpl').html());
                    },
                },
            });
        });
    }

    _initGivePoint() {
        const open  = () => { $('#point-give-backdrop').show(); $('#point-give-box').show(); };
        const close = () => { $('#point-give-backdrop').hide(); $('#point-give-box').hide(); };
        $('#btn-give-point').on('click', open);
        $('#btn-give-cancel').on('click', close);
        $('#point-give-backdrop').on('click', close);
        $('#btn-give-apply').on('click', () => {
            const price = parseInt($('#give-price').val(), 10);
            const reason = $('#give-reason').val();
            if (isNaN(price)) {
                alert('포인트를 숫자만 넣어주세요');
                return;
            }
            $.ajax({
                type: 'POST',
                url: '/m/ajax/member/point/admin',
                data: { jobnum: 0, pointval: price, jobmemo: reason },
                success: () => location.reload(),
            });
        });
    }
}

